import { useQuery } from "@apollo/client";

import { ProjectReviewVisitV2FunctionList_GetDataDocument } from "../queries.generated";

export function useProjectReviewVisitV2FunctionList_GetData(
    visitId: string,
    pageSize: number,
    page: number,
    layerId?: string,
) {
    const { data, loading, error, previousData } = useQuery(ProjectReviewVisitV2FunctionList_GetDataDocument, {
        variables: {
            visitId,
            ecologicalFunctionSearchParams: {
                pageSize,
                page,
                layerId,
            },
            observationSearchParams: {
                pageSize,
                page,
                layerId,
            },
        },
        fetchPolicy: "cache-and-network",
        nextFetchPolicy: "cache-first",
    });

    const result = loading ? previousData : data;

    return {
        loading,
        error,
        ecologicalFunctions: {
            data: result?.ecologicalFunctionsByVisitGetAll.data,
            queryInfo: result?.ecologicalFunctionsByVisitGetAll.queryInfo,
        },
        observations: {
            data: result?.plannerVisitPossibleFunctions.data,
            queryInfo: result?.plannerVisitPossibleFunctions.queryInfo,
        },
    };
}
